import ListPageView from "../../components/ListPageView"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"
import ActivityLogSidebar from "../../components/sidebars/ActivityLogSidebar"

export default function ContactLog() {
  const ID_TEMPLATE = "contact_log"
  const ID_BLOCKS = ["activity__contact_log", "activity"]

  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Contact Name",
      field: "contact_name_first|contact_name_last",
      block: "activity__contact_log",
      type: "concatenation",
    },
    {
      header: "Submitted By",
      field: "staff_full_name",
      block: "activity",
      type: "staff",
    },
    {
      header: "Location",
      field: "activity__location_ids",
      block: "activity",
      type: "location",
    },
    {
      header: "Program ID",
      field: "activity__program_identity_ids",
      block: "activity",
      type: "program",
    },
  ]
  return (
    <>
      <PageSidebarContent>
        <ActivityLogSidebar />
      </PageSidebarContent>
      <div className="main-content">
        <ListPageView
          idTemplate={ID_TEMPLATE}
          idBlocks={ID_BLOCKS}
          columns={listViewCols}
        />
      </div>
    </>
  )
}
